var MyPlate = MyPlate || {};
MyPlate.effect = MyPlate.effect || {};

MyPlate.effect.birthdayBalloons = (function($){

  const NUMBER_OF_BALLOONS = 50;
  const BALLOON_DIR = '/themes/custom/myplate/assets/img/myplate/birthday-balloons';
  const BALLOON_FILES = [
    `${BALLOON_DIR}/balloon1.svg`,
    `${BALLOON_DIR}/balloon2.svg`,
    `${BALLOON_DIR}/balloon3.svg`,
    `${BALLOON_DIR}/balloon4.svg`,
    `${BALLOON_DIR}/balloon5.svg`,
    `${BALLOON_DIR}/balloon6.svg`,
    `${BALLOON_DIR}/balloon7.svg`,
    `${BALLOON_DIR}/balloon8.svg`,
    `${BALLOON_DIR}/balloon9.svg`,
  ];
  const START_X_RANGE = [20, 80]; // the x coordinate used for start
  const END_X_RANGE = [-20, 120]; // the x coordinate used for end
  const WIDTH_RANGE = [100, 200]; // the width of the balloon
  const ROTATE_RANGE = [-8, 8]; // degree of balloon rotation
  const SPEED_RANGE = [2000, 6000]; // how fast the balloon move
  const DELAY_RANGE = [0, 7000]; // how long before the balloon starts

  //////////

  // $(function(){
  //   // Chrome seems to need this delay, otherwise it appears to not
  //   // register the CSS rules via insertRule!
  //   setTimeout(function(){
  //     run();
  //   }, 1000);
  // });

  //////////

  function run() {
    const $canvas = $('<div class="mp-effect-birthday-balloons">');
    $('body').append($canvas);
    const sheet = createStylesheet();
    createBalloons($canvas, sheet);
  }

  function createBalloons($el, sheet) {
    for (i = 0; i < NUMBER_OF_BALLOONS; i++) {
      const id = `balloon-${i}`;
      const animationName = `anim-${id}`;
      const balloonIndex = Math.round(Math.random() * BALLOON_FILES.length);
      const balloonName = BALLOON_FILES[balloonIndex];
      const $tag = $('<div>').addClass('balloon').attr('id', id);
      const $img = $('<img>').attr('src', balloonName);
      $tag.append($img);

      const leftStart = Math.round(getRandomNumberInRange(START_X_RANGE[0], START_X_RANGE[1])) + '%';
      const leftEnd = Math.round(getRandomNumberInRange(END_X_RANGE[0], END_X_RANGE[1])) + '%';
      $tag.css({
        left: leftStart,
      });

      const width = Math.round(getRandomNumberInRange(WIDTH_RANGE[0], WIDTH_RANGE[1])) + 'px';
      const rotate = Math.round(getRandomNumberInRange(ROTATE_RANGE[0], ROTATE_RANGE[1])) + 'deg';
      $img.css({
        width: width,
        transform: `rotate(${rotate})`,
      });

      $el.append($tag);

      //
      // The jquery.keyframe.js library does not work consistently in Chrome!
      //

      // $.keyframe.define({
      //   name: animationName,
      //   from: {
      //     left: leftStart,
      //     bottom: '0px',
      //     transform: 'translateY(100%)',
      //   },
      //   to: {
      //     left: leftEnd,
      //     bottom: '100%',
      //     transform: 'translateY(0px)',
      //   }
      // });
      // @keyframes anim-balloon-0 { \n  0% { left: 62%; bottom: 0px; transform: translateY(100%); }\n  100% { left: 85%; bottom: 100%; transform: translateY(0px); }\n}
      sheet.insertRule(`@keyframes ${animationName} { from { left: ${leftStart}; bottom: 0px; transform: translateY(100%); } to { left: ${leftEnd}; bottom: 100%; transform: translateY(0px); }}`);
      // sheet.insertRule(`#${id} { color: red; bottom: 50% !important; }`);

      const animationDuration = Math.round(getRandomNumberInRange(SPEED_RANGE[0], SPEED_RANGE[1]));
      const delay = Math.round(getRandomNumberInRange(DELAY_RANGE[0], DELAY_RANGE[1]));
      // $tag.playKeyframe({
      //   name: animationName,
      //   duration: `${animationDuration}ms`,
      //   timingFunction: 'ease-in',
      //   delay: `${delay}ms`,
      //   iterationCount: 1,
      //   fillMode: 'forwards',
      //   // complete: function(){
      //   //   // console.log(`Done with ${animationName}`);
      //   // }
      // });
      $tag.css({
        animation: `${animationDuration}ms ease-in ${delay}ms 1 normal forwards ${animationName}`,
      });
    }
  }

  function getRandomNumberInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  function createStylesheet() {
    // Create the <style> tag
    var style = document.createElement('style');

    // Add a media (and/or media query) here if you'd like!
    // style.setAttribute('media', 'screen')
    // style.setAttribute('media', 'only screen and (max-width : 1024px)')

    // WebKit hack :(
    style.appendChild(document.createTextNode(''));

    // Add the <style> element to the page
    document.head.appendChild(style);

    return style.sheet;
  }

  return {
    run: run
  };

})(jQuery);
